import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  TableHead,
  TableRow,
  TableCell,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core';
import { v1 as uuid } from 'uuid';
import firstRowColumns from './FirstRowColumns';
import secondRowColumns from './SecondRowColumns';

const ReportCardCustomHeaderStudent = (props) => {
  const { t, columns } = props;

  const headerTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          textTransform: 'capitalize',
          minWidth: '200px',
          borderBottom: 'none',
          padding: '10px',
          fontSize: '13px',
          borderRight: '1px solid white',
          textAlign: 'left !important',
        },
        head: {
          color: '#fff',
          background: '#202BA2',
          lineHeight: '0.7rem',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          '&:first-child': {
            position: 'sticky',
            left: 0,
            zIndex: 999,
          },
        },
      },
      MuiTableHead: {
        root: {
          position: 'sticky',
          background: '#202BA2',
          top: 0,
          zIndex: 10,
        },
      },
    },
  });

  const secondaryRowTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          textTransform: 'capitalize',
          borderBottom: 'none',
          padding: '3.5px 10px',
          fontSize: '13px',
          borderRight: '1px solid white',
        },
        head: {
          background: '#9d5fbe',
          borderTop: '1px solid white',
          color: 'white',
          position: 'sticky',
        },
      },
      MuiTableHead: {
        root: {
          position: 'sticky',
          background: '#202BA2',
          top: 0,
          zIndex: 10,
        },
      },
    },
  });

  const col = columns.reduce((obj, item) => {
    if (!obj[item.subject]) {
      const reassign = obj;
      reassign[item.subject || item.title] = [];
    }
    obj[item.subject || item.title].push(item);
    return obj;
  }, {});

  const convertToArrayOfObjects = Object.keys(col).map((name) => {
    return {
      name,
      fields: col[name],
    };
  });

  return (
    <ThemeProvider theme={headerTheme}>
      <TableHead>
        <TableRow>
          {firstRowColumns(t, convertToArrayOfObjects).map((column) => (
            <TableCell key={uuid()} {...column.customProps}>
              {column.title}
            </TableCell>
          ))}
        </TableRow>
        <TableRow>
          {secondRowColumns(t, convertToArrayOfObjects).map((column) => (
            <ThemeProvider key={uuid()} theme={secondaryRowTheme}>
              <TableCell {...column.customProps}>{column.title}</TableCell>
            </ThemeProvider>
          ))}
        </TableRow>
      </TableHead>
    </ThemeProvider>
  );
};

ReportCardCustomHeaderStudent.propTypes = {
  t: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      render: PropTypes.func,
      subject: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
};

export default withTranslation('common')(ReportCardCustomHeaderStudent);
